import React from 'react'
import { Link as RouterLink } from 'react-router-dom-v5-compat'
import MuiLink from '@mui/material/Link'

const Link = props => {
  return <MuiLink component={RouterLink} {...props} />
}

export default Link
